import {
  SET_CURRENT_USER,
  NOT_ENTER_USER,
  SET_USER_LOGOUT,
  NOT_FIND_USER,
  SET_PERMISSION,
  SET_IS_OPEN_GLOBAL_SIDEBAR,
  SET_BODY_GLOBAL_SIDEBAR
} from 'contexts/actions/actionTypes';

export default (state, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        auth: {
          isAuthenticated: Object.keys(action.payload).length !== 0,
          user: action.payload
        }
      };
    case NOT_ENTER_USER:
      return {
        ...state,
        auth: { ...state, isLogin: true }
      };
    case NOT_FIND_USER:
      return {
        ...state,
        auth: { ...state, isLogin: true, error: 406 }
      };

    case SET_USER_LOGOUT:
      return {
        ...state,
        auth: {
          ...state,
          isAuthenticated: false,
          isLogin: false,
          user: {}
        },
        user: {
          ...state,
          user: null,
          isLoading: false,
          permission: undefined
        }
      };

    case SET_PERMISSION: {
      return {
        ...state,
        permission: action.payload
      };
    }
    case SET_IS_OPEN_GLOBAL_SIDEBAR:
      return {
        ...state,
        isOpenGlobalSideBar: action.payload
      };

    case SET_BODY_GLOBAL_SIDEBAR:
      return {
        ...state,
        bodyGlobalSideBar: action.payload
      };

    default:
      return state;
  }
};
